<div class="filters-wrapper" [ngClass]="{ 'filter-sort': filterCriteria === 'sort' }">
  @for (filter of filters | filterGroupBy: filterCriteria; track filter) {
    @if (filter.options && filter.options.length > 0) {
      @if (filter.type === 'multi-select') {
        <app-multi-select [list]="filter.options" [name]="filter.name" (shareCheckedList)="getCheckedList($event, filter)" />
      }
      @if (filter.type === 'select') {
        <app-select-dropdown [list]="filter.options" [name]="filter.name" (shareValueSelected)="getCheckedList($event, filter)" />
      }
      @if (filter.type === 'radio') {
        <app-radio-select [list]="filter.options" [name]="filter.name" (shareValueSelected)="getCheckedList($event, filter)" />
      }
    }
  }
  @if (filterCriteria !== 'sort') {
    <app-filter-tags [values]="tagsArray" (tagEvent)="removeTagEvent($event)" (removeAllTagsEvent)="removeAllTags()" />
  }
</div>
